import React from 'react';
import block from 'bem-cn-lite';
import ResizedImage from 'components/ResizedImage/ResizedImage';

import './AuthorBlock.scss';

export enum AuthorBlockType {
    Column = 'column',
    Line = 'line',
}

export interface Author {
    firstName: string;
    secondName: string;
    description?: string;
    avatar?: string;
}
export interface AuthorBlockProps {
    author: Author;
    className?: string;
    type?: AuthorBlockType;
}

const b = block('AuthorBlock');

const AuthorBlock: React.FC<AuthorBlockProps> = (props) => {
    const {author, className, type = AuthorBlockType.Column} = props;
    const {firstName, secondName, description, avatar} = author;

    const name = secondName ? `${firstName} ${secondName}` : firstName;

    return (
        <div className={b({type}, className)}>
            {avatar && (
                <div className={b('avatar')}>
                    <ResizedImage options={{url: avatar}} />
                </div>
            )}
            <div className={b('label')}>
                <div className={b('name')}>{name}</div>
                {description || ''}
            </div>
        </div>
    );
};

export default AuthorBlock;
